//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import PlansMixin from '~/mixins/plans'

export default {
  mixins: [PlansMixin],
  props: {
    /**
     * Area: diet | sex-drive | stress | energy | sleep
     */
    area: {
      type: String,
      required: true
    },
    /**
     * Test plan title
     */
    title: {
      type: String,
      required: true
    },
    /**
     * Test plan description
     */
    description: {
      type: String,
      required: true
    },
    /**
     * Test plan type: blood | saliva
     */
    type: {
      type: String,
      default: null
    },
    /**
     * Show the link: Show More
     */
    showButtonShowMore: {
      type: Boolean,
      default: true
    },
    /**
     * Test plan show more text
     */
    showMore: {
      type: String,
      required: true
    },
    /**
     * Test plan show more url
     */
    showMoreUrl: {
      type: String,
      default: null
    },
    /**
     * Whether the image behaves as show more
     */
    showMoreInImage: {
      type: Boolean,
      required: false
    },
    /**
     * Test plan button add text
     */
    buttonAdd: {
      type: String,
      default: null
    },
    /**
     * Test plan button added text
     */
    buttonAdded: {
      type: String,
      default: null
    },
    /**
     * Test plan image
     */
    image: {
      type: String,
      required: true
    },
    /**
     * Test plan image
     */
    imageMobile: {
      type: String,
      required: true
    },
    /**
     * Plan to add
     */
    plan: {
      type: String,
      default: 'base-monitor'
    },
    goalData: {
      type: Object,
      default: null
    },
    hrefAddButton: {
      type: String,
      required: false,
      default: null
    },
    showPrice: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('product', ['planSelected', 'isGift']),
    ...mapState('quiz', ['goalId']),
    ...mapGetters({
      isAreaSelected: 'product/isAreaSelected',
      getPlanPriceRaw: 'product/getPlanPriceRaw',
      isMonitorPlan: 'product/isMonitorPlan'
    }),
    imageWrapper () {
      return this.showMoreInImage ? 'nuxt-link' : 'div'
    },
    isGoalQuizPlanAdded () {
      return (this.isQuizPlanResults || this.isBaseImprovementPlan) && this.goalId === this.goalData.goalId
    }
  },
  methods: {
    addArea () {
      if (this.isAreaSelected(this.area) && this.isMonitorPlan) {
        return this.$store.dispatch('product/removeArea', this.area)
      }
      if (this.plan === 'base-quiz-results' || this.plan === 'base-improvement-plan' || this.plan === 'base-improvement-plan-pay-upfront') {
        const { goalId, starterTest, starterTestId } = this.goalData
        this.addQuizPlanToCart({ plan: this.plan, area: this.area, goalId, starterTest, starterTestId })
      }
      if (this.hrefAddButton) {
        this.addMonitorToCart({ area: this.area })
        location.href = this.hrefAddButton
      }
      this.addMonitorToCart({ area: this.area })
    }
  }
}
